export default "__VITE_ASSET__DJ3FTE7e__"